var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exclusive-finish"},[_c('img',{attrs:{"src":_vm.tipImage}}),_c('p',{staticClass:"big-text"},[_vm._v("专属价格已失效")]),_c('p',[_vm._v("专属价格已过期或已被使用")]),_c('button',{on:{"click":_vm.back}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }